// @flow
import React from "react"
import classnames from "classnames"
import type { Node, Element } from "react"

import ButtonWrapper from "../ButtonWrapper/ButtonWrapper"
import type { ButtonSize, ButtonKind } from "../ButtonWrapper/ButtonWrapper"

type Props = {
  size: ButtonSize,
  kind: ButtonKind,
  children: Node,
  fullwidth?: boolean,
  disabled?: boolean,
  iconLeft?: ?Element<any>,
  iconRight?: ?Element<any>,
  className?: string,
  onClick: (SyntheticMouseEvent<>) => void,
  dataTest?: string,
  rel?: string,
  target?: string,
  href?: string,
}

const ButtonLink = ({
  children,
  iconLeft,
  iconRight,
  className,
  disabled,
  onClick,
  size,
  fullwidth,
  kind,
  dataTest,
  rel,
  target,
  href,
}: Props) => (
  <ButtonWrapper
    size={size}
    kind={kind}
    fullwidth={fullwidth}
    disabled={disabled}
    className={classnames("ButtonLink", className)}
  >
    <a href={href} onClick={onClick} rel={rel} target={target} data-test={dataTest}>
      <span className="ButtonWrapper-content">
        {iconLeft && <span className="ButtonLink-icon _left">{iconLeft}</span>}
        {children}
        {iconRight && <span className="ButtonLink-icon _right">{iconRight}</span>}
      </span>
    </a>
  </ButtonWrapper>
)

ButtonLink.defaultProps = {
  size: "medium",
  kind: "primary",
  onClick: () => {},
}

export default ButtonLink
